/**
 * Initialize header
 *
 * @param {HTMLElement} root
 */
const init = (root) => {
	root.classList.add('initialized');

	let scrollMemo = 0;

	const submenuIsVisible = root.querySelector('.is-active > .level-2');

	if (submenuIsVisible) {
		document.documentElement.style.setProperty('--logo-position', 'fixed');
	} else {
		document.documentElement.style.setProperty('--header-position', 'fixed');
	}

	const handleHeaderVisibility = () => {
		const scrollPos = window.scrollY;
		const headerHeight = root.clientHeight;
		const submenuHeight = submenuIsVisible?.clientHeight || 84;
		const ctaButton = root.querySelector('.c-link-button-position');

		document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
		ctaButton.classList.remove('c-link-button-position--fixed', 'c-link-button-position--relative');

		if (!submenuIsVisible) {
			document.documentElement.style.setProperty('--header-top', '0');
			document.documentElement.style.setProperty('--main-margin-top', `${headerHeight}px`);
			ctaButton.classList.remove('c-link-button-position--fixed');
			ctaButton.classList.add('c-link-button-position--relative');
		} else if (scrollPos > scrollMemo) {
			document.documentElement.style.setProperty('--header-top', `-${headerHeight}px`);
			ctaButton.classList.remove('c-link-button-position--relative');

			if (scrollPos > headerHeight - submenuHeight / 2) {
				document.documentElement.style.setProperty('--logo-height', `${submenuHeight}px`);
				ctaButton.classList.add('c-link-button-position--fixed');
			}
		} else {
			document.documentElement.style.setProperty('--logo-height', `${headerHeight}px`);
			ctaButton.classList.remove('c-link-button-position--fixed');
			ctaButton.classList.add('c-link-button-position--relative');

			if (scrollPos > headerHeight) {
				document.documentElement.style.setProperty('--header-top', `0px`);
			}
		}

		scrollMemo = scrollPos <= 0 ? 0 : scrollPos;
	};

	handleHeaderVisibility();
	['resize', 'scroll'].forEach((eventName) =>
		window.addEventListener(
			eventName,
			() => {
				handleHeaderVisibility();
			},
			false
		)
	);
};

export const initHeader = (root = document) => {
	const header = root.querySelector('.js-header:not(.initialized)');
	if (header) {
		init(header);
	}
};
